import { render, staticRenderFns } from "./SiteIndex.vue?vue&type=template&id=2f0606d3&scoped=true&"
import script from "./SiteIndex.vue?vue&type=script&lang=js&"
export * from "./SiteIndex.vue?vue&type=script&lang=js&"
import style0 from "./SiteIndex.vue?vue&type=style&index=0&id=2f0606d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0606d3",
  null
  
)

export default component.exports